import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  getTaskManagementRemindPaginated,
  ITaskManagementRemindPaginatedResponse,
} from "api";
import { Nullable } from "config";
import { store } from "store";

import { RemindModalModes } from "./enums";
import { IRemindModalData } from "./types";

const initialState = {
  remindData: null as Nullable<ITaskManagementRemindPaginatedResponse["edges"]>,
  totalCount: 1,
  loading: false,
  modalData: {
    mode: RemindModalModes.VIEW,
    open: false,
    loading: false,
  } as IRemindModalData,
};

export const fetchRemindList = createAsyncThunk(
  "remind/fetchRemindList",
  async () => {
    const filters = store.getState().FiltersReducer;
    if (!Object.values(filters).length) {
      return;
    }
    const response = await getTaskManagementRemindPaginated(filters);
    return response;
  }
);

const remindSlice = createSlice({
  name: "remind",
  initialState,
  reducers: {
    setRemindModalData: (state, action: PayloadAction<IRemindModalData>) => {
      state.modalData = action.payload;
    },
    closeRemindModal: (state) => {
      state.modalData = initialState.modalData;
    },
    setRemindModalLoading: (state, action: PayloadAction<boolean>) => {
      state.modalData.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchRemindList.fulfilled, (state, action) => {
      if (!action.payload) return;
      return {
        ...state,
        remindData: action.payload
          ?.edges as ITaskManagementRemindPaginatedResponse["edges"],
        totalCount: action.payload?.totalCount,
        loading: false,
      };
    });
    builder.addCase(fetchRemindList.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
  },
});

export const { setRemindModalData, closeRemindModal, setRemindModalLoading } =
  remindSlice.actions;

export default remindSlice.reducer;
